import { Subject } from 'rxjs';
export const createEmitAction = ()=>{
    const action$ = new Subject();
    const emitAction = ()=>action$.next();
    return {
        action$,
        emitAction
    };
};
